export const STATUS_META = {
  registration_open: { label: "REGISTRATION OPEN", dot: "#34d399", cls: "text-emerald-400 border-emerald-400/40 bg-emerald-400/10" },
  coming_soon: { label: "COMING SOON", dot: "#facc15", cls: "text-yellow-400 border-yellow-400/40 bg-yellow-400/10" },
  closed: { label: "REGISTRATION CLOSED", dot: "#f87171", cls: "text-red-400 border-red-400/40 bg-red-400/10" },
  completed: { label: "EVENT COMPLETED", dot: "#94a3b8", cls: "text-slate-400 border-slate-400/40 bg-slate-400/10" },
};

export default function StatusBadge({ status }) {
  const meta = STATUS_META[status] || STATUS_META.completed;
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[10px] tracking-[0.15em] ${meta.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full animate-pulse" style={{ background: meta.dot }} />
      {meta.label}
    </span>
  );
}
